import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogoMark } from "../components/Logo";
import { http, errMsg } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await http.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <main data-testid="admin-login-page" className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative overflow-hidden">
        <img src="/images/hero_street.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <img src="/images/hero_oldmoney.jpg" alt="" className="absolute inset-0 w-full h-full object-cover [clip-path:inset(0_0_0_50%)]" />
      </div>
      <div className="bg-[var(--ivory)] text-[var(--navy)] flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm">
          <LogoMark size={40} />
          <h1 className="f-serif italic text-5xl mt-8 mb-10">Panel</h1>
          <label className="f-mono text-[11px] uppercase tracking-[0.25em]">E-posta</label>
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 mb-6 w-full bg-transparent border-b border-[var(--navy)]/30 focus:border-[var(--navy)] outline-none py-3" />
          <label className="f-mono text-[11px] uppercase tracking-[0.25em]">Şifre</label>
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 mb-8 w-full bg-transparent border-b border-[var(--navy)]/30 focus:border-[var(--navy)] outline-none py-3" />
          {error && <p data-testid="admin-login-error" className="text-red-600 text-sm mb-4">{error}</p>}
          <button data-testid="admin-login-submit" disabled={busy} className="w-full h-12 rounded-full bg-[var(--navy)] text-[var(--ivory)] f-mono text-[12px] uppercase tracking-[0.25em] disabled:opacity-60">
            {busy ? "..." : "Giriş"}
          </button>
        </form>
      </div>
    </main>
  );
}
